function cov_1lzwyrirqj() {
  var path = "/app/src/components/long-term-content/components/installment-item-skeleton/installment-item-skeleton.tsx";
  var hash = "c48ae8bca33eaf35f2e8920773bbb853bfb0e22d";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/components/long-term-content/components/installment-item-skeleton/installment-item-skeleton.tsx",
    statementMap: {
      "0": {
        start: {
          line: 5,
          column: 39
        },
        end: {
          line: 7,
          column: 1
        }
      },
      "1": {
        start: {
          line: 6,
          column: 2
        },
        end: {
          line: 6,
          column: 41
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 5,
            column: 39
          },
          end: {
            line: 5,
            column: 40
          }
        },
        loc: {
          start: {
            line: 5,
            column: 45
          },
          end: {
            line: 7,
            column: 1
          }
        },
        line: 5
      }
    },
    branchMap: {},
    s: {
      "0": 0,
      "1": 0
    },
    f: {
      "0": 0
    },
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "c48ae8bca33eaf35f2e8920773bbb853bfb0e22d"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1lzwyrirqj = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1lzwyrirqj();
import React from 'react';
import styles from './styles.css';
cov_1lzwyrirqj().s[0]++;
export var InstallmentItemSkeleton = function InstallmentItemSkeleton() {
  cov_1lzwyrirqj().f[0]++;
  cov_1lzwyrirqj().s[1]++;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.body
  });
};